const statusToLabel = (value: string | undefined): string => {
  switch (value) {
    case "requesting":
      return "依頼中";
    case "completed":
      return "完了";
    case "failed":
      return "失敗";
    default:
      return "";
  }
};

const isRequestCompleted = (value: string): boolean => {
  return value === "completed";
};

export { statusToLabel, isRequestCompleted };
